import React, { useEffect } from 'react';
import { Router, Route, Switch, Redirect, RouteProps } from 'react-router-dom';
import { history } from '../helpers';

import Login from '../modules/login/login';
import AuthLayout from '../layout/layout';
import Dashboard from '../modules/dashboard/dashboard';
import TermsOfUse from '../shared/components/termsOfUse/termsOfUseModal';
import { ChangePassword } from '../modules/login/changePassword';
import { shareSessioStorageBetweenTabs } from '../helpers/manageStorage';
import { RenderPDFReport } from '../modules/dashboard/studies/components/pdfReports/render';
import useChat from '../shared/hooks/useChat';
import { useTypedSelector } from '../hooks/useTypedSelector';

interface PrivateRootProps extends RouteProps {}

const PrivateRoute = ({ component, path }: PrivateRootProps) => {
  const logInStorage = sessionStorage.token;
  const { logIn } = useTypedSelector((state) => state.layoutState);

  useEffect(() => {
    shareSessioStorageBetweenTabs();
  }, []);

  return (
    <Route
      exact
      path={path}
      render={(props) =>
        logInStorage || logIn ? (
          <AuthLayout>
            {component ? React.createElement(component, { ...props }) : null}
          </AuthLayout>
        ) : (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        )
      }
    />
  );
};

const AppRoutes = () => {
  useChat();
  return (
    <Router history={history}>
      <Switch>
        <Route path="/login" exact={true} component={Login} />
        <Route path="/change-password/:id">
          <ChangePassword />
        </Route>
        <PrivateRoute path="/" exact component={Dashboard} />
        <PrivateRoute path="/map/:idDashboard" exact component={Dashboard} />
        <PrivateRoute path="/terms-of-use" exact component={TermsOfUse} />
        <Route path="/pdf-mock/:img" component={RenderPDFReport} />
        <Route path="*" render={() => <Redirect to="/" />} />
      </Switch>
    </Router>
  );
};

export default AppRoutes;
